import React, { Component, PropTypes } from 'react';
import TextArea from '../textarea';
import Input from '../input';
import Select from 'react-select';
import Card from '../tc-ui/card';
import languagesObj from '../../localization/languages.json';
import { setOnboardingFields } from '../../stores/onboarding/onboarding-actions';
import {
    marketSegments,
    nonAccomCompanyTypes,
    accomCompanyTypes,
    contractorCompanyTypes,
    countries as countriesServed } from '../../utils/select-fields';
import { curry } from 'ramda';
const languageSettings = languagesObj['en-US'];

class ContactInfo extends Component {

  changeMultiSelectValue = curry((name, optsArray) => {
    this.props.dispatch(setOnboardingFields({ [name]: optsArray ? optsArray.map(({ value }) => value) : [] }));
  });

  render() {
    let multiSelects;
    const errorStyle = {
      background: '#fff0f0',
      borderColor: '#dbb1b1',
      color: '#d95c5c',
      borderRadius: '0 .2857rem .2857rem 0',
    };
    if (this.props.userType === 'Contractor') {
      multiSelects = (
        <div>
          <div className="l-paper-split-form">
            <div className="field">
              <div className="l-paper-left">
                <label htmlFor="" className="form-label">{languageSettings.onboarding.companyTypes}</label>
              </div>
              <div className="l-paper-right">
                <Select
                  name={ "companyTypes"}
                  onChange={this.changeMultiSelectValue('companyTypes')}
                  options={contractorCompanyTypes}
                  value={this.props.onboarding.companyTypes}
                  style={this.props.multiSelectErrors.companyTypes ? errorStyle : {}}
                  multi
                />
              </div>
            </div>
          </div>
          <div className="l-paper-split-form">
            <div className="field">
              <div className="l-paper-left">
                <label htmlFor="" className="form-label">{languageSettings.onboarding.countriesServed}</label>
              </div>
              <div className="l-paper-right">
              <Select
                name={ "countriesServed"}
                onChange={this.changeMultiSelectValue('countriesServed')}
                options={countriesServed}
                value={this.props.onboarding.countriesServed}
                style={this.props.multiSelectErrors.countriesServed ? errorStyle : {}}
                multi
              />
                <p className="multi-select-paragraph"><em>{languageSettings.onboarding.destinationsSoldDesc}</em></p>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.props.userType === 'Supplier') {
      if (this.props.productType === 'Non-Accommodation') {
        multiSelects = (
          <div className="l-paper-split-form">
            <div className="field">
              <div className="l-paper-left">
                <label htmlFor="" className="form-label">{languageSettings.onboarding.companyTypes}</label>
              </div>
              <div className="l-paper-right">
              <Select
                name="companyTypes"
                onChange={this.changeMultiSelectValue('companyTypes')}
                options={nonAccomCompanyTypes}
                value={this.props.onboarding.companyTypes}
                style={this.props.multiSelectErrors.companyTypes ? errorStyle : {}}
                multi
              />
              </div>
            </div>
          </div>
        );
      } else if (this.props.productType === 'Accommodation') {
        // Property Types
        multiSelects = (
          <div className="l-paper-split-form">
            <div className="field">
              <div className="l-paper-left">
                <label htmlFor="" className="form-label">{languageSettings.onboarding.propertyTypes}</label>
              </div>
              <div className="l-paper-right">
                <Select
                  name={ "companyTypes"}
                  onChange={this.changeMultiSelectValue('companyTypes')}
                  options={accomCompanyTypes}
                  value={this.props.onboarding.companyTypes}
                  style={this.props.multiSelectErrors.companyTypes ? errorStyle : {}}
                  multi
                />
              </div>
            </div>
          </div>
        );
      }
    }
    return (
      <Card
        className="on-boarding-card"
        title={languageSettings.onboarding.aboutYourCompany}
        subtitle={languageSettings.onboarding.required}
      >

       <div className="l-paper-split-form">
         <div className="field">
           <div className="l-paper-left">
             <label className="form-label"></label>
           </div>
           <div className="l-paper-right">
             <p>{languageSettings.onboarding.textAreaParagraph}</p>
           </div>
         </div>
       </div>

       <div className="l-paper-split-form">
         <div className="field">
           <div className="l-paper-left">
             <label htmlFor="websiteUrl" className="form-label">{languageSettings.onboarding.website}</label>
           </div>
           <div className="l-paper-right">
             <Input name="websiteUrl" id="websiteUrl" defaultValue={this.props.websiteUrl} type={ "text"} />
           </div>
         </div>
       </div>

       <div className="l-paper-split-form textarea">
         <div className="field">
           <div className="l-paper-left">
             <label htmlFor="description" className="form-label short-description">{languageSettings.onboarding.shortDescription}</label>
           </div>
           <div className="l-paper-right">
             <TextArea id="description" name="description" defaultValue={this.props.description} required />
             <p className="multi-select-paragraph onboarding-short-description-reminder"><em>{languageSettings.onboarding.shortDescriptionReminder}</em></p>
           </div>
         </div>
       </div>

       {multiSelects}

       <div className="l-paper-split-form">
         <div className="field">
           <div className="l-paper-left">
             <label className="form-label">{languageSettings.onboarding.marketSegments}</label>
           </div>
           <div className="l-paper-right">
               <Select
                 name={ "marketSegments"}
                 onChange={this.changeMultiSelectValue('marketSegments')}
                 options={marketSegments}
                 value={this.props.onboarding.marketSegments}
                 multi
                 style={this.props.multiSelectErrors.marketSegments ? errorStyle : {}}
               />
             <p className="multi-select-paragraph"><em>{languageSettings.onboarding.marketSegmentsDesc}</em></p>
           </div>
         </div>
       </div>
      </Card>
    );
  }
}

ContactInfo.propTypes = {
  onChange: PropTypes.func,
  description: PropTypes.string,
  websiteUrl: PropTypes.string,
  companyTypes: PropTypes.array,
  userType: PropTypes.string,
  productType: PropTypes.string,
  countriesServed: PropTypes.array,
  onboarding: PropTypes.object,
  dispatch: PropTypes.func,
  multiSelectErrors: PropTypes.object,
};

export default ContactInfo;



// WEBPACK FOOTER //
// ./src/app/components/onboarding/about-your-company.jsx